// extracted by mini-css-extract-plugin
module.exports = {"container":"PlCapture_container__3n3Ws"};